import { useEffect, useState } from "react";
import TrainingReportMainData from "./trainingReportMainData";
import TrainingReportToolbar from "./trainingReportToolbar";
import TrainingReportTel1 from "./trainingReportTel1";
import TrainingReportTel2 from "./trainingReportTel2";
import TrainingReportSummary from "./trainingReportSummary";
import TrainingReportParticipant from "./trainingReportParticipant";
import TrainingReportTel3 from "./trainingReportTel3";
import TrainingReportFile from "./trainingReportFile";
function DetailTraining() {
  const [refreshTel2State, setRefreshTel2State] = useState(1);
  const [mainData, setMainData] = useState();
  const handleUpdate = () => {
    setRefreshTel2State((prev) => prev + 1);
  };

  return (
    <>
      <ul className="breadcrumb">
        <li className="breadcrumb-item">
          <a href="#/">TRAINING</a>
        </li>
        <li className="breadcrumb-item active">Detail</li>
      </ul>
      <h1 className="page-header">
        Training Report <small></small>
      </h1>
      <hr className="mb-4" />
      <TrainingReportToolbar />
      <div className="row gx-4">
        <div className="col-lg-8">
          <TrainingReportMainData mainDataRet={(e) => setMainData(e)} />
        </div>
        <div className="col-lg-4">
          <TrainingReportSummary />
        </div>
        <div className="col-lg-12">
          <TrainingReportParticipant onUpdate={handleUpdate} />
        </div>
        <div className="col-lg-12">
          <TrainingReportTel2 refresh={refreshTel2State} />
        </div>
        <div className="col-lg-12">
          <TrainingReportTel1 />
        </div>
        <div className="col-lg-12">
          <TrainingReportTel3 startDate={mainData?.startDate ?? null} />
        </div>
        <div className="col-lg-12">
          <TrainingReportFile />
        </div>
      </div>
    </>
  );
}
export default DetailTraining;
